/* eslint-disable no-plusplus */
/* eslint-disable no-console */
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { AWBNumberNormslization } from '../../../services/utility';
import UserIPTracking from '../../../interface/userTracker';
import { sendIPTrackingData } from '../../../services/userIPTrack';


export default {
  name: 'RecStatus',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {

      // for status list
      Status: '',
      StatusList: [],
      RecList: [],
      recreasons: '',
      description: '',
      awbnumber: '',
      awbArray: [],
      awbno: '',
      errorFlag: 0,
      success: false,
      error: false,
      actionCondition: '',
      finalhublist: [],
      allHublist: [],
      destination: '',
      default: false,
      dropSubStatus: '',
      username: '',
      show: false,
      loading: false,
      sendingData: false,
      takeActionname: '',
      recReault: '',
      recFailed: '',
      recSuccess: '',
      RecReasonDisable: true,
      AWBLength: 0,
      daylist: [{
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }]
      ,
      day: ''
    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.status();
    // this.recReason();
    this.destination = '301';
  },

  methods: {

    getfinalhublist() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getHubdropdownlist`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        if (result.data.code === 200) {
          for (let i = 0; i < result.data.data.length; i++) {
            if (result.data.data[i].HubID === 301) {
              this.finalhublist.push({
                id: result.data.data[i].HubID,
                label: result.data.data[i].HubName,
              });
            }
          }
        } else {
          console.error('Data not found for Hub');
        }
      },
        (error) => {
          console.error(error);
        });
    },

    status() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}status`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const statusdata = [];
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.statuscode,
            label: status.statusname,
          });
        });
        this.StatusList = statusdata;
      },
        (error) => {
          console.error(error);
        });
    },
    recReason() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}recReasons`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const recdata = [];
        result.data.data.forEach((id) => {
          recdata.push({
            id: id.recreasonsid,
            label: id.recreason,
          });
        });
        this.RecList = recdata;
      },
        (error) => {
          console.error(error);
        });
    },

    resetForm() {
      this.awbnumber = '', this.day = '', this.description = '', this.recreasons = '', this.takeActionname = '',
        this.actionCondition = '', this.isLoading = false;
      this.$refs["awb"].value = "";
      this.$validator.reset(); this.errors.clear();
    },

    selectOption(event) {
      this.actionName = event.target.name
      this.RecReasonDisable = true;
      this.actionCondition = this.takeActionname;
      this.finalhublist = [];
      this.recreasons = ''
      this.RecList = [];
      if (this.takeActionname === '1') {
        this.getfinalhublist();
      }
      if (this.takeActionname === '15') {
        this.recReason();
        this.RecReasonDisable = false;
      }
    },
    submit() {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString()
      let AWBNumber = this.awbnumber
      AWBNumber = AWBNumber.split(',')
      if (!this.awbnumber) {
        this.$alertify.error("Please enter valid AWB number.")
      } else if (!this.actionCondition) {
        this.$alertify.error("Please select action.")
      } else if (!this.recreasons.id && this.takeActionname === '15') {
        this.$alertify.error("Please select RECReason.")
      } else if (!this.description) {
        this.$alertify.error("Please Fill Description.")
      }
      else {
        this.sendingData = true;
        this.loading = true;
        this.input = ({
          ShippingID: this.awbnumber,
          actionstatusid: parseInt(this.actionCondition, 10),
          reasonId: this.recreasons.id,
          description: this.description,
          username: this.username,
          destinationId: this.destination
        });
        
          axios({
            method: 'post',
            url: apiUrl.api_url + 'UpdateRECReason',
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + this.myStr
            }

          }).then(result => {
            this.loading = false;
            this.recReault = result;
            this.recFailed = result.data.data.failed;
            this.recSuccess = result.data.data.Success;
            this.AWBLength = AWBNumber.length
            this.resetForm()
            this.sendingData = false;
            this.loading = false;
          }).catch((error) => {
            console.error(error);
            this.loading = false;
          });
        }
  
    },

    calCulateAWBLength() {
      let AWBLength = this.awbnumber
      AWBLength = AWBLength.replace(/[ ,]+/g, ",");
      AWBLength = AWBLength.replace(/\t/g, ",");
      AWBLength = AWBLength.replace(/,\s*$/, "");
      AWBLength = AWBLength.replace(/,,/g, ",");
      AWBLength = AWBLength.split(',')
      return AWBLength.length;
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Rec/Rec.component.js